@if (problem(); as problem) {
  <sb-empty-state
    [icon]="problem.icon"
    [attr.role]="problem.role"
    [title]="problem.title | translate"
    [description]="problem.description | translate"
  >
    @switch (problem.action) {
      @case ('retry') {
        <button sb-button color="primary" (click)="retry.emit()">{{ 'Try again' | translate }}</button>
      }
      @case ('uploadAgain') {
        <button sb-button color="primary" (click)="uploadAgain.emit()">{{ 'Upload again' | translate }}</button>
      }
    }
    <button sb-button [color]="problem.action ? 'secondary' : 'primary'" (click)="setUpManually.emit()">
      {{ 'Set up manually' | translate }}
    </button>
  </sb-empty-state>
} @else {
  <div class="flex flex-col items-center gap-md text-center">
    <sb-branded-loader size="lg" [delay]="0" [loadingLabel]="'Checking your contract' | translate" />
    <p class="reset-p text-lg font-bold text-default" aria-live="polite">
      {{ phrase() | translate }}
    </p>
    @if (fileName(); as name) {
      <p class="reset-p flex items-center gap-xs font-normal text-default" data-hj-suppress>
        <sb-icon name="document-2-regular" />
        {{ name }}
      </p>
    }
    @if (!ready()) {
      <p class="reset-p text-support">{{ 'Longer contracts can take a few minutes.' | translate }}</p>
      <button
        type="button"
        class="reset-button cursor-pointer text-brand hover:underline"
        (click)="setUpManually.emit()"
      >
        {{ 'Skip and set up manually' | translate }}
      </button>
    }
  </div>
}
